import type customerPurchasesId from "./id";

const customerPurchasesEn: typeof customerPurchasesId = {
	customer_purchases: {
		title: "Purchase Report",
		empty_state: {
			title: "No purchase report data yet",
			description: "Reports appear once customers have made a purchase.",
		},
		tables: {
			title: "Customer Purchase Report",
			columns: {
				name: "Name",
				phone_number: "Phone Number",
				email: "Email",
				qty: "Qty",
				total: "Total Purchase",
			},
		},
	},
};

export default customerPurchasesEn;
